import styled from '@emotion/styled';
import { Container, Navbar } from 'react-bootstrap';
import { shadow } from 'app/colors';

const StyledNavbar = styled(Navbar)(
  {
    backgroundColor: 'var(--color-background-white)',
  },
  shadow
);

const SubNavigationBar = ({
  className,
  expand = 'sm',
  toggle = true,
  children,
  label = <></>,
  ...props
}) => {
  return (
    <StyledNavbar expand={expand} {...props}>
      <Container>
        <Navbar.Brand style={{ margin: 0 }}>{label}</Navbar.Brand>
        {toggle && <Navbar.Toggle />}
        <Navbar.Collapse id="sub-nav-collapse">{children}</Navbar.Collapse>
      </Container>
    </StyledNavbar>
  );
};

export default SubNavigationBar;
